import React, { Component } from 'react';
import * as d3 from 'd3';
import "./radiobtn.css";


class RadioToggle extends Component {
  constructor(props){
      super(props);
      this.state = {
        selected: this.props.selected
      }
      //this.radioList = this.props.radioList;
   }
  render() {
    let classlist;
    //let activeClass = this.props.selected?'active':'';
    classlist = `radio-btn ${this.props.classList?this.props.classList:''}`;

    let toggleId = this.props.id;
    let optionIndex = this.props.optionIndex;
    let label = this.props.optionLabel;

    return (
      <React.Fragment>
        <input type="radio" checked={(this.props.selected === this.props.optionParams)} id={`${toggleId}-option-${optionIndex}`} name={`${toggleId}-options`} onChange={()=>this.props.btnClick()}/>
        <label htmlFor={`${toggleId}-option-${optionIndex}`}> {label} </label>
      </React.Fragment>
    )
  }
}

export default RadioToggle;
